module.exports = __webpack_public_path__ + "static/media/maximise.1edb8d08.svg";